import { httpEnrollmentClient } from '../common/httpClient';
import API_CONST from '@/constants/ApiConst';

export function getElasticApplicationDetails(elasticEnrollmentId: string) {
  return httpEnrollmentClient().get(`${API_CONST.ELASTIC_ENROLLMENT}/${elasticEnrollmentId}`).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function getElasticApplicationsIdDetails(scholarId: string) {
  return httpEnrollmentClient().get(`${API_CONST.ELASTIC_ENROLLMENT_BY_SCHOLAR}/${scholarId}`).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function getApplicationDetails(applicationId: string) {
  return httpEnrollmentClient().get(`${API_CONST.APPLICATION}/${applicationId}`).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function saveApplicationForms(formsPayload: any) {
  return httpEnrollmentClient().post(`${API_CONST.SAVE_FORMS_ELASTIC}`, formsPayload).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function saveApplicationFormsInDB(formsList: any) {
  return httpEnrollmentClient().post(`${API_CONST.ELASTIC_ENROLLMENT}`, formsList).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function saveApplicationPartSecond(scholarId: string, formsList: any) {
  return httpEnrollmentClient().put(`${API_CONST.ELASTIC_ENROLLMENT}?scholarId=${scholarId}`, formsList).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function getScholarDetails(scholarId: string) {
  return httpEnrollmentClient().get(`${API_CONST.SCHOLAR_INFO}/${scholarId}`).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}

export function getUserDetails(payload: any) {
  return httpEnrollmentClient().get(`${API_CONST.GUARDIAN_INFO}/${payload}`).then((response) => {
    return { data: response.data, status: response.status, statusText: response.statusText };
  }).catch((error) => {
    const res = error;
    return { data: (res.data.Message || res.data.value || res.data), status: res.status, statusText: res.statusText };
  });
}